module.exports = __webpack_public_path__ + "img/pattern-icon-2.56a2dd34.png";